import axios from "axios";

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/esignature`;

const createClaimUrl = (data) => axios.post(`${apiUrl}/claimUrl`, data);

const deleteClaimUrl = () => axios.delete(`${apiUrl}/claimUrl`);

const createSignatureIds = (data) => axios.post(`${apiUrl}/signatureIds`, data);

const createSignUrl = ({ signatureId }) =>
  axios.post(`${apiUrl}/signUrl`, {
    signatureId,
  });

const createEmailReminder = (data) =>
  axios.post(`${apiUrl}/email-reminder`, data);

const voidCompany = (data) => axios.put(`${apiUrl}/voidCompany`, data);

const createAcount = (data) => axios.post(`${apiUrl}/accounts`, data);

const esignatureService = {
  createClaimUrl,
  deleteClaimUrl,
  createSignatureIds,
  createSignUrl,
  createEmailReminder,
  voidCompany,
  createAcount,
};

export default esignatureService;
